import type { ParagraphTranslations } from "./pl";

export const en: ParagraphTranslations = {
  unsupportedLayout: (n) => `Paragraph type ${n}`,
  unsupportedLayoutBody:
    "— this layout is not supported by the renderer. The paragraph exists in the database but its layout has not been implemented in the component.",

  attachments: {
    heading: "Attachments",
    download: "Download file",
    sizeMb: (mb) => `${mb} MB`,
  },

  gallery: {
    openImage: "Open image in full view",
    image: "Image",
    empty: "No images in this paragraph.",
  },

  video: {
    youtubeTitleFallback: "YouTube video",
    missing: "Video is unavailable (no source).",
  },

  blogPosts: {
    empty: "No related blog posts.",
    open: (name) => `Open post: ${name}`,
    viewMore: "View more",
  },

  map: {
    empty: "No points to display on the map.",
    loading: "Loading map…",
  },

  contactForm: {
    heading: "Contact form",
    labels: {
      phone: "Phone",
      email: "E-mail",
      text: "Message",
      personalData: "I consent to the processing of my personal data",
    },
    rodoDefault:
      "I consent to the processing of my personal data for the purpose of handling this enquiry.",
    submit: "Send message",
    sending: "Sending…",
    validation: {
      requiredField: (label) => `Field "${label}" is required.`,
      invalidEmail: "Please enter a valid e-mail address.",
      invalidPhone: "Please enter a valid phone number.",
      requiredPersonalData: "Consent to data processing is required.",
    },
    status: {
      sendSuccess: "Message sent. Thank you for getting in touch.",
      sendFailed: "Could not send the message. Please try again shortly.",
      rateLimit:
        "Too many attempts from this IP. Please wait a moment before trying again.",
      tokenExpired: "Form session has expired. Refresh the page and try again.",
      antiSpam:
        "Suspicious activity detected. Please review the form and try again.",
      waitBeforeSubmit: (sec) =>
        `Please wait ${sec} more second(s) before submitting the form.`,
      networkError: (msg) => `Network error: ${msg}.`,
      networkErrorGeneric: "Failed to reach the server. Please try again.",
    },
  },
};
